import type {
  AgeData,
  Aggregations,
  ReferenceData,
} from '@cinch-nx/data-search'
import type { MakesMapping } from './types'

class Options {
  private _useMonthly = false
  private _mappings: MakesMapping = {
    makes: {},
    models: {},
    variants: {},
  }
  private _ageData: AgeData[] = []
  private _facets: Aggregations | undefined = undefined
  private _storeData: ReferenceData[] = []

  public get useMonthly() {
    return this._useMonthly
  }

  public set useMonthly(useMonthly: boolean) {
    this._useMonthly = useMonthly
  }

  public get mappings() {
    return this._mappings
  }

  public set mappings(mappings: MakesMapping) {
    this._mappings = mappings
  }

  public get ageData() {
    return this._ageData
  }

  public set ageData(ageData: AgeData[]) {
    this._ageData = ageData
  }

  public get facets() {
    return this._facets
  }

  public set facets(facets: Aggregations | undefined) {
    this._facets = facets
  }

  public get storeData() {
    return this._storeData
  }

  public set storeData(storeData: ReferenceData[]) {
    this._storeData = storeData
  }
}

export const options = new Options()
